import { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as timetravelActions from "./actions/timetravel.actions.actions";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import { BackendButton } from "../auth/BackendButton";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

const ReloansysBar = (props) => {
  const [date, setDate] = useState(new Date());
  const { currentTime } = props.timeTravel;
  useEffect(() => {
    props.getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let backgroundColor = "#55ab96";

  if (import.meta.env.MODE === "production") {
    backgroundColor = "#f3e5b2";
  }

  const barStyle = {
    border: "solid 1px black",
    backgroundColor,
    padding: "10px",
  };

  return import.meta.env.MODE === "development" ? (
    <div style={barStyle}>
      Re-Loansys: Current time is:{" "}
      {moment(new Date(currentTime)).format("YYYY-MM-DD HH:mm:ss")}
      <br />
      <DatePicker
        inputVariant="outlined"
        className="small-datepicker"
        label="Choose date to timetravel"
        onChange={handleChangeDate}
        value={date}
      />
      <div style={{ marginTop: "15px", display: "inline-block" }}>
        <Button variant="contained" onClick={changeDate}>
          change Date
        </Button>
        <BackendButton label={"Backend Admin"} url={"/frontpage"} />
      </div>
    </div>
  ) : (
    <div style={barStyle}>
      <BackendButton label={"Backend Admin"} url={"/frontpage"} />
    </div>
  );

  function changeDate() {
    props.setDate(date);
  }

  function handleChangeDate(date) {
    setDate(date);
  }
};

function mapStateToProps(state) {
  return {
    timeTravel: state.timeTravel,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDate: () => {
      dispatch(timetravelActions.get_date());
    },

    setDate: (date) => {
      let formatedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss");
      dispatch(timetravelActions.set_date(formatedDate));
    },

    openBackendView: (path) => {
      dispatch(timetravelActions.set_path(path));
    },
  };
}
export const backendAdminConnect = connect(mapStateToProps, mapDispatchToProps);
export default backendAdminConnect(ReloansysBar);
